import { ASSET_TYPES } from './assetTypes';
export const OBJECT_TYPE_IDS = {
  LANDING_PAGE: '0-25',
  WEB_INTERACTIVE: '0-91'
};
export const OBJECT_TYPE_ID_TO_ASSET_TYPE = {
  '0-25': ASSET_TYPES.LANDING_PAGE,
  '0-91': ASSET_TYPES.WEB_INTERACTIVE
};